"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskCompletenessReducer = exports.filterTaskCompleteness = exports.generateDefaultCompletenessState = exports.initialCompletenessState = exports.nextCompletenessState = exports.TaskCompletenessContext = exports.taskCompletenessActions = void 0;
const react_1 = __importDefault(require("react"));
const types_1 = require("../entities/fact/types");
const constants_1 = require("../tasks/constants");
const tasks_1 = require("../tasks");
const types_2 = require("../types");
const capability_1 = require("../util/capability");
exports.taskCompletenessActions = {
    initialise: (taskCompleteness, requireSectionReviews) => ({
        type: 'INITIALISE',
        payload: { completion: taskCompleteness, requireSectionReviews }
    }),
    setLocalLicenceCompleteness: (localLicenceCompleteness) => ({
        type: 'SET_LOCAL_LICENCE_COMPLETENESS',
        payload: localLicenceCompleteness,
    }),
};
exports.TaskCompletenessContext = react_1.default.createContext({});
const nextCompletenessState = (valid, current) => {
    if (valid) {
        if (current !== types_1.TaskCompletionState.REVIEW_REQUIRED) {
            return { completion: types_1.TaskCompletionState.COMPLETE };
        }
        else {
            // No-op
            return { completion: current };
        }
    }
    else {
        return { completion: types_1.TaskCompletionState.INPUT_REQUIRED };
    }
};
exports.nextCompletenessState = nextCompletenessState;
const initialCompletenessState = (capabilities) => {
    const requireSectionReviews = (0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.RequireSectionReviews);
    return (0, exports.generateDefaultCompletenessState)(requireSectionReviews);
};
exports.initialCompletenessState = initialCompletenessState;
const generateDefaultCompletenessState = (requireSectionReviews) => {
    return Object.keys(constants_1.Tasks).reduce((all, curr) => {
        const config = tasks_1.TaskDetails[curr];
        if (config.initReviewRequired && requireSectionReviews) {
            all[curr] = { completion: types_1.TaskCompletionState.REVIEW_REQUIRED };
        }
        else if (config.readOnly || config.validationRequirements === undefined) {
            all[curr] = { completion: types_1.TaskCompletionState.COMPLETE };
        }
        else {
            all[curr] = { completion: types_1.TaskCompletionState.INPUT_REQUIRED };
        }
        return all;
    }, {});
};
exports.generateDefaultCompletenessState = generateDefaultCompletenessState;
const filterTaskCompleteness = (taskCompleteness, requireSectionReviews) => Object.entries(taskCompleteness)
    .filter(([_, completion]) => !!completion)
    .reduce((acc, [task, completion]) => {
    /* If we don't require section reviews (as is the case in edit mode), we don't need the task completeness
    state as it is only used to determine if tasks require review when onboarding or adding a property. */
    return requireSectionReviews ? Object.assign(Object.assign({}, acc), { [task]: completion }) : {};
}, {});
exports.filterTaskCompleteness = filterTaskCompleteness;
const taskCompletenessReducer = (state, action) => {
    // Log out actions that are firing when running locally
    if (process.env.LOCAL_DEV) {
        console.debug(action);
    }
    switch (action.type) {
        case 'INITIALISE':
            const defaultCompletionState = (0, exports.generateDefaultCompletenessState)(action.payload.requireSectionReviews);
            const defaultCompletionStateKeys = Object.keys(defaultCompletionState);
            const loadedTaskCompletenessFiltered = (0, exports.filterTaskCompleteness)(action.payload.completion, action.payload.requireSectionReviews);
            const loadedTaskCompletenessKeys = Object.keys(loadedTaskCompletenessFiltered);
            const completionState = defaultCompletionStateKeys.reduce((accumulated, curr) => {
                // if the curr key existed before return its completion otherwise get the default completion
                return loadedTaskCompletenessKeys.includes(curr)
                    ? Object.assign(Object.assign({}, accumulated), { [curr]: action.payload.completion[curr] }) : Object.assign(Object.assign({}, accumulated), { [curr]: defaultCompletionState[curr] });
            }, {});
            return completionState;
        case 'SET_LOCAL_LICENCE_COMPLETENESS':
            return Object.assign(Object.assign({}, state), { [constants_1.Tasks.LOCAL_LICENCE]: { completion: action.payload } });
        case 'VISIT_TASK_PAGE':
            const visitCaseCurrent = state[action.payload.task].completion;
            if (visitCaseCurrent === types_1.TaskCompletionState.REVIEW_REQUIRED) {
                return Object.assign(Object.assign({}, state), { [action.payload.task]: { completion: types_1.TaskCompletionState.COMPLETE } });
            }
            else {
                return state;
            }
        case 'UPDATE_TASK_VALIDATION':
            const updates = Object.keys(action.payload).reduce((all, key) => {
                all[key] = (0, exports.nextCompletenessState)(action.payload[key], state[key].completion);
                return all;
            }, {});
            return Object.assign(Object.assign({}, state), updates);
        default:
            return state;
    }
};
exports.taskCompletenessReducer = taskCompletenessReducer;
//# sourceMappingURL=TaskCompletenessContext.js.map